import React from "react";
import Accordions from "../../../components/Accordions";

const Sem1Csd1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/12UfYp_aYrbcd39L00oMEzJb7CvP5CHRx/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/110b28E74y0iipnfNDaTADpmFUj6wcjfj/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1BMeWQjs8JOvW6REOMwOHKbOsJr3XAVxH/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">CSD Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1Csd1;
